import { Label } from "semantic-ui-react";

const ShortcutComment = ({ comments, fieldName, fieldValue, setFieldValue }) => {
	return comments.map((comment, i) => (
		<Label
			key={"comment-" + i}
			style={{ cursor: "pointer" }}
			onClick={() => setFieldValue(fieldName, fieldValue === "" ? comment : fieldValue.concat("\n", comment))}
		>
			{comment}
		</Label>
	));
};

export default ShortcutComment;
